import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import {
  ButtonModule,
  DrawerModule,
  IconsModule,
  ModalModule,
  NotificationsModule,
  ProductsModule,
  UiComponentsModule,
} from '@fcom/ui-components';
import { UiTranslateModule } from '@fcom/ui-translate';
import { CmsModule } from '@fcom/cms/components';
import { TabsModule } from '@fcom/common-booking/modules/tabs';
import { ComponentsModule } from '@fcom/common/components/components.module';
import { DirectiveModule } from '@fcom/common/directives/directive.module';
import { FinFormsModule } from '@fcom/common/forms';
import { GtmModule } from '@fcom/common/gtm/gtm.module';
import { PipesModule } from '@fcom/common/pipes/pipes.module';
import { CommonBookingComponentsModule } from '@fcom/common-booking/components';
import { CommonBookingAncillariesModule } from '@fcom/common-booking/modules';
import { AncillarySubviewModule } from '@fcom/common-booking/modules/ancillaries/components/ancillary-subview/ancillary-subview.module';

import { BookingNotificationModule } from '../../components/booking-notification/booking-notification.module';
import { AncillaryService } from './services/ancillary.service';
import { AncillariesGuard } from './services/ancillaries.guard';
import { BookingAncillariesRouteComponent } from './routes/booking-ancillaries-route.component';
import { SmpComponent } from './components/smp/smp.component';
import { AncillariesComponent } from './components/ancillaries.component';
import { BookingCommonModule } from '../common/booking-common.module';

@NgModule({
  imports: [
    BookingCommonModule,
    CommonModule,
    ComponentsModule,
    CommonBookingComponentsModule,
    CommonBookingAncillariesModule,
    DirectiveModule,
    GtmModule,
    PipesModule,
    TabsModule,
    CmsModule,
    FinFormsModule,
    AncillarySubviewModule,
    UiTranslateModule,
    ButtonModule,
    IconsModule,
    ModalModule,
    DrawerModule,
    ProductsModule,
    NotificationsModule,
    UiComponentsModule,
    BookingNotificationModule,
  ],
  declarations: [AncillariesComponent, BookingAncillariesRouteComponent, SmpComponent],
  providers: [AncillaryService, AncillariesGuard],
})
export class AncillariesModule {}
